import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Inventory.module.scss';
import { InventoryItem, ConnectModal } from '../../components';
import chestBronze from '../../assets/imgs/chest-bronze-70x70-2x.png';
import chestSilver from '../../assets/imgs/chest-silver-70x70-2x.png';
import chestGold from '../../assets/imgs/chest-gold-70x70-2x.png';
import { Web3Context } from '../../web3/Web3Context';
import { Button, Image } from 'react-bootstrap';
import ChestIcon from '../../assets/icons/icon-chest.svg';
import ChestIconGray from '../../assets/icons/icon-chest-gray.svg';
import CardsIcon from '../../assets/icons/icon-cards.svg';
import CardsIconGray from '../../assets/icons/icon-cards-gray.svg';
import TicketIcon from '../../assets/icons/icon-ticket.svg';
import TicketIconGray from '../../assets/icons/icon-ticket-gray.svg';
import MapIcon from '../../assets/icons/icon-maps.png';
import MapIconGray from '../../assets/icons/icon-maps-gray.png';
import SkinIcon from '../../assets/icons/icon-skin.svg';
import SkinIconGray from '../../assets/icons/icon-skin-gray.svg';
import IconEthereum from '../../assets/icons/icon-ethereum.svg';
import IconPolygon from '../../assets/icons/polygon-matic-logo52x52.svg';
// import IconListView from '../../assets/icons/icon-list-view.svg';
// import IconHistory from '../../assets/icons/icon-history.svg';
import { ethers } from 'ethers';
import { TokenContext, ABIContext, TYPES } from '../../components/Context';
import { fromWei } from 'web3-utils';
import CardsListing from '../../components/CardsListing/CardsListing';
import { useHistory, useParams } from 'react-router-dom';
import Spinner from '../../components/Spinner/Spinner';
import OpenSeaIcon from '../../assets/icons/icon-opensea-simple.svg';
import IconOpenSeaWhite from '../../assets/icons/icon_opensea_white.png';
import { Web3Environment } from 'ethenv';
import { Tickets } from '../../components/Tickets';
import { Skins } from '../../components/Skins/Skins';
import { Maps } from '../../components/Maps/Maps';
import { createContract } from '../../services/contractService';
import { erc20Abi } from '../../abis/erc20Abi';
import { PolygonNetworkInfo } from '../../services/networkServices';

// const OPENSEA_COLLECTION_URL = process.env.REACT_APP_OPENSEA_COLLECTION_URL;
const openSeaBattleCardUrl = "https://opensea.io/collection/tower-battle-cards";
const CARD_NFTS_ENABLED = process.env.REACT_APP_CARD_NFTS_ENABLED;
const MAPS_NFTS_ENABLED = process.env.REACT_APP_MAP_NFTS_ENABLED;
const SKIN_AND_TICKET_BRIDGING_ENABLED = process.env.REACT_APP_SKIN_AND_TICKET_BRIDGING_ENABLED;

const Inventory = (props) => {
    const history = useHistory();
    const { type } = useParams();
    const [t] = useTranslation();
    const { selectedAccount, networkId, connect, web3, provider, switchNetwork } = useContext(Web3Context);
    const [selectedInventorySection, setSelectedInventorySection] = useState('');
    const [walletConnected, setWalletConnected] = useState(false);
    const [state, dispatch] = useContext(TokenContext);
    const [abiConfig, abiDispatch] = useContext(ABIContext);
    const [chestOpening, setChestOpening] = useState(false);
    const [showConnectModal, setShowConnectModal] = useState(false);
    const [goldOperator, setGoldOperator] = useState();
    const [silverOperator, setSilverOperator] = useState();
    const [bronzeOperator, setBronzeOperator] = useState();
    const [goldToken, setGoldToken] = useState();
    const [silverToken, setSilverToken] = useState();
    const [bronzeToken, setBronzeToken] = useState();

    const {
        inventory: { inventoryContract },
        ethereumProvider,
        polygonProvider,
        polygonDeploymentContext,
        ethereumDeploymentContext
    } = abiConfig;

    const initializeInventoryContract = async () => {
        let contract = await createContract(polygonDeploymentContext, 'CDHInventory', provider);

        if (contract) {
            abiDispatch({
                type: TYPES.INIT_INVENTORY_CONTRACT,
                payload: {
                    inventoryAddress: contract.options.address,
                    inventoryContract: contract,
                    erc20Abi: erc20Abi
                },
            });
        }
    }

    useEffect(() => {
        if (provider && polygonProvider && polygonDeploymentContext) {
            if (networkId === 1 || networkId === 137 || networkId === 5 || networkId === 80001) {
                resetOnNetworkChange();
                initializeInventoryContract();
            } else {
                resetOnNetworkChange();
            }
        }
    }, [networkId, polygonProvider, polygonDeploymentContext])

    const resetOnNetworkChange = () => {
        const chestCount = {
            gold: "0",
            silver: "0",
            bronze: "0",
        }

        dispatch({
            type: TYPES.SET_CHEST_COUNT_MATIC,
            payload: chestCount,
        });

        dispatch({
            type: TYPES.SET_CHEST_COUNT_GOERLI,
            payload: chestCount,
        });

        dispatch({
            type: TYPES.SET_TOTAL_CARD_COUNT,
            payload: "0",
        });

        abiDispatch({
            type: TYPES.INIT_INVENTORY_CONTRACT,
            payload: {
                inventoryAddress: null,
                inventoryContract: null,
                erc20Abi: {},
            },
        });
    }

    useEffect(() => {
        if (type === "chests") {
            setSelectedInventorySection("chests");
        } else if (type === "cards") {
            setSelectedInventorySection("cards");
        } else if (type === "tickets") {
            setSelectedInventorySection("tickets");
        } else if (type === "skins") {
            setSelectedInventorySection("skins");
        } else if (type === "maps") {
            setSelectedInventorySection("maps");
        } else {
            setSelectedInventorySection("cards");
        }
    }, [type]);

    useEffect(() => {
        (async () => {
            if (selectedAccount && polygonProvider && polygonDeploymentContext) {
                try {
                    let web3M = await Web3Environment.get(process.env.REACT_APP_MATIC_PROVIDER_URL, process.env.REACT_APP_MATIC_DEPLOYMENT_CONTEXT_URL);
                    let goldTkn = await web3M.getContract("TOWERChest-GOLD", web3);
                    let silverTkn = await web3M.getContract("TOWERChest-SLVR", web3);
                    let bronzeTkn = await web3M.getContract("TOWERChest-BRNZ", web3);
                    let goldOp = await web3M.getContract("OperatorGoldChest", web3);
                    let silverOp = await web3M.getContract("OperatorSilverChest", web3);
                    let bronzeOp = await web3M.getContract("OperatorBronzeChest", web3);

                    setGoldToken(goldTkn);
                    setSilverToken(silverTkn);
                    setBronzeToken(bronzeTkn);
                    setGoldOperator(goldOp);
                    setSilverOperator(silverOp);
                    setBronzeOperator(bronzeOp);
                } catch (error) {
                    console.error("Error creating contracts", error);
                }
            }
        })();
    }, [selectedAccount, polygonProvider, polygonDeploymentContext])

    useEffect(() => {
        if (selectedAccount && ethereumProvider && polygonProvider && inventoryContract && polygonDeploymentContext && ethereumDeploymentContext
            && (networkId === 1 || networkId === 5 || networkId === 80001 || networkId === 137)) {

            fetchMaticChests(polygonProvider, polygonDeploymentContext.contracts, erc20Abi);
            fetchEthereumChests(ethereumProvider, ethereumDeploymentContext.contracts, erc20Abi);

            fetchCardsCount();
        }

        if (selectedAccount) {
            setWalletConnected(true);
        } else {
            setWalletConnected(false);
        }
    }, [abiConfig, selectedAccount]);

    useEffect(() => {
        let { gold: Ggold, silver: Gsilver, bronze: Gbronze } = state.chestBalance.goerli;
        let { gold: Mgold, silver: Msilver, bronze: Mbronze } = state.chestBalance.matic;

        let totalChestCount = parseInt(Ggold) + parseInt(Gsilver) + parseInt(Gbronze) + parseInt(Mgold) + parseInt(Msilver) + parseInt(Mbronze);

        dispatch({
            type: TYPES.SET_TOTAL_CHEST_COUNT,
            payload: totalChestCount,
        });
    }, [state.chestBalance])

    const fetchCardsCount = async () => {
        try {
            const inventoryInstance = new ethers.Contract(
                polygonDeploymentContext.contracts['CDHInventory'].address,
                polygonDeploymentContext.contracts['CDHInventory'].abi,
                polygonProvider,
            );

            let cardsCount = await inventoryInstance.count(selectedAccount);
            cardsCount = await cardsCount.toString();
            dispatch({
                type: TYPES.SET_TOTAL_CARD_COUNT,
                payload: cardsCount,
            });
        } catch (err) {
            console.log(err);
        }
    }

    const fetchChestCount = async (provider, chestAddress, erc20Abi) => {
        const chestContract = new ethers.Contract(
            chestAddress,
            erc20Abi,
            provider,
        );
        let balanceOfChest = await chestContract.balanceOf(
            selectedAccount,
        );

        let fromWeiBalance = Number(fromWei(balanceOfChest.toString()));
        let balance = (Math.round(fromWeiBalance * 100) / 100).toFixed(2);
        return balance;
    };

    const fetchMaticChests = async (provider, contracts, erc20Abi) => {
        try {
            const goldChestAddress = contracts['TOWERChest-GOLD'].address;
            let goldChestAmount = await fetchChestCount(provider, goldChestAddress, erc20Abi);
            const silverChestAddress = contracts['TOWERChest-SLVR'].address;
            let silverChestAmount = await fetchChestCount(provider, silverChestAddress, erc20Abi);
            const bronzeChestAddress = contracts['TOWERChest-BRNZ'].address;
            let bronzeChestAmount = await fetchChestCount(provider, bronzeChestAddress, erc20Abi);

            const chestCount = {
                gold: Math.trunc(goldChestAmount.toString()),
                silver: Math.trunc(silverChestAmount.toString()),
                bronze: Math.trunc(bronzeChestAmount.toString()),
            }

            dispatch({
                type: TYPES.SET_CHEST_COUNT_MATIC,
                payload: chestCount,
            });
        } catch (e) {
            console.log(`Error: ${e}`);
        }
    }

    const fetchEthereumChests = async (provider, contracts, erc20Abi) => {
        try {
            const goldChestAddress = contracts['TOWERChest-GOLD'].address;
            let goldChestAmount = await fetchChestCount(provider, goldChestAddress, erc20Abi);
            const silverChestAddress = contracts['TOWERChest-SLVR'].address;
            let silverChestAmount = await fetchChestCount(provider, silverChestAddress, erc20Abi);
            const bronzeChestAddress = contracts['TOWERChest-BRNZ'].address;
            let bronzeChestAmount = await fetchChestCount(provider, bronzeChestAddress, erc20Abi);

            const chestCount = {
                gold: Math.trunc(goldChestAmount.toString()),
                silver: Math.trunc(silverChestAmount.toString()),
                bronze: Math.trunc(bronzeChestAmount.toString()),
            }

            dispatch({
                type: TYPES.SET_CHEST_COUNT_GOERLI,
                payload: chestCount,
            });
        } catch (e) {
            console.log(`Error: ${e}`);
        }
    }

    const ethereumChestsData = {
        gold: {
            img: chestGold,
            title: t('GOLD_CHEST'),
            amount: state.chestBalance.goerli.gold,
            name: 'gold',
            tokenContractName: 'TOWERChest-GOLD'
        },
        silver: {
            img: chestSilver,
            title: t('SILVER_CHEST'),
            amount: state.chestBalance.goerli.silver,
            name: 'silver',
            tokenContractName: 'TOWERChest-SLVR'
        },
        bronze: {
            img: chestBronze,
            title: t('BRONZE_CHEST'),
            amount: state.chestBalance.goerli.bronze,
            name: 'bronze',
            tokenContractName: 'TOWERChest-BRNZ'
        }
    };

    const polygonChestsData = {
        gold: {
            img: chestGold,
            title: t('GOLD_CHEST'),
            amount: state.chestBalance.matic.gold,
            name: 'gold',
            operatorContract: goldOperator,
            operatorContractName: 'OperatorGoldChest',
            tokenContract: goldToken,
            tokenContractName: 'TOWERChest-GOLD'
        },
        silver: {
            img: chestSilver,
            title: t('SILVER_CHEST'),
            amount: state.chestBalance.matic.silver,
            name: 'silver',
            operatorContract: silverOperator,
            operatorContractName: 'OperatorSilverChest',
            tokenContract: silverToken,
            tokenContractName: 'TOWERChest-SLVR'
        },
        bronze: {
            img: chestBronze,
            title: t('BRONZE_CHEST'),
            amount: state.chestBalance.matic.bronze,
            name: 'bronze',
            operatorContract: bronzeOperator,
            operatorContractName: 'OperatorBronzeChest',
            tokenContract: bronzeToken,
            tokenContractName: 'TOWERChest-BRNZ'
        }
    };

    const renderChests = (
        <div className={styles.items_section}>
            {/* <div className={styles.items_listing_options}>
                <div className={`${styles.listing_option} ${styles.selected}`} style={{ marginRight: '5px' }}>
                    <div className={styles.list_image}>
                        <img src={IconListView} alt="list-view" />
                    </div>
                    Chest Listing
                </div>
                <div className={styles.listing_option}>
                    <div className={styles.list_image}>
                        <img src={IconHistory} alt="list-view" />
                    </div>
                    Transaction History
                </div>
            </div> */}
            <div className={styles.items_container}>
                <div className={styles.network_based_items}>
                    <div className={styles.item_head}>
                        <div className={styles.head_image} style={{ backgroundColor: "#151C2F" }}>
                            <img src={IconEthereum} alt="ethereum" />
                        </div>
                        <div>
                            <div className={styles.network_title}>{t('NETWORK')}</div>
                            <div className={styles.network_name}>{t('ETHEREUM')}</div>
                        </div>
                    </div>
                    {
                        Object.keys(ethereumChestsData).map((chest, i) => {
                            return <InventoryItem key={i} content={{
                                type: 'ethereum',
                                image: ethereumChestsData[chest].img,
                                text: ethereumChestsData[chest].title,
                                amount: ethereumChestsData[chest].amount,
                                name: ethereumChestsData[chest].name,
                                tokenContractName: ethereumChestsData[chest].tokenContractName
                            }}
                                selectedAccount={selectedAccount}
                            />
                        })
                    }
                </div>
                <div className={`${styles.network_based_items} ${styles.polygon_items}`}>
                    <div className={styles.item_head}>
                        <div className={styles.head_image} style={{ backgroundColor: "#F1E9FA" }}>
                            <img src={IconPolygon} alt="polygon" />
                        </div>
                        <div>
                            <div className={styles.network_title}>{t('NETWORK')}</div>
                            <div className={styles.network_name}>{t('POLYGON')}</div>
                        </div>
                    </div>
                    {
                        Object.keys(polygonChestsData).map((chest, i) => {
                            return <InventoryItem key={i} content={{
                                type: 'polygon',
                                image: polygonChestsData[chest].img,
                                text: polygonChestsData[chest].title,
                                amount: polygonChestsData[chest].amount,
                                name: polygonChestsData[chest].name,
                                operatorContract: polygonChestsData[chest].operatorContract,
                                operatorContractName: polygonChestsData[chest].operatorContractName,
                                tokenContract: polygonChestsData[chest].tokenContract,
                                tokenContractName: polygonChestsData[chest].tokenContractName
                            }}
                                setChestOpening={setChestOpening}
                                fetchMaticChests={fetchMaticChests}
                                web3={web3}
                                selectedAddress={selectedAccount}
                                selectedAccount={selectedAccount}
                            />
                        })
                    }
                </div>
            </div>
            {chestOpening && <Spinner
                show={true}
                headerText="Opening Chests"
            />}
        </div>
    );

    const renderChestSection = (
        <>
            {walletConnected ?
                renderChests :
                <div className={styles.no_items_section}>
                    <div className={styles.main_text}>{t('CONNECT_WALLET_ACCESS_INVENTORY')}</div>
                    <div className={styles.secondary_text}>{t('NO_ITEMS_WITHOUT_CONNECT')}</div>
                    <Button variant="cdh-general-blue-dbrown" className={styles.primary_btn} onClick={connect}>{t('CONNECT')}</Button>
                </div>}
        </>
    );

    const renderCardsSection = (
        <>
            {walletConnected ?
                networkId == parseInt(process.env.REACT_APP_POLYGON_CHAIN_ID) ?
                state.totalCardCount > 0 ?
                    <div className={styles.items_section}>
                        <CardsListing
                            inventoryContract={inventoryContract}
                            web3={web3}
                            selectedAccount={selectedAccount}
                            fetchCardsCount={fetchCardsCount}
                        />
                    </div> :
                    <div className={styles.no_items_section}>
                        <div className={styles.main_text}>{t('CARDS_EMPTY_TITLE')}</div>
                        <div className={styles.secondary_text}>{t('BUY_ON_OPENSEA')}</div>
                        <div className={styles.button_group}>
                            <a href={openSeaBattleCardUrl} target="_blank">
                                <Button variant="cdh-general-blue-dbrown" className={styles.secondary_btn}>
                                    <Image width="15" height="15" className={styles.opensea_icon} src={IconOpenSeaWhite} alt="opensea" />
                                    <span className={styles.opensea_btn_text}>{t('GO_OPENSEA_BTN')}</span>
                                </Button>
                            </a>
                            
                            {/* Hide the buy chest button */}
                            {/* <Button variant="cdh-general-blue-dbrown" className={styles.primary_btn} onClick={() => history.push('/', { chest_sale: true })}>
                                {t('GO_BUY_CHEST_BTN')}
                            </Button> */}
                        </div>
                    </div>
                :
                <div className={styles.switch_polygon_section}>
                    <span className={styles.switch_polygon_text}>{t('CONFIRM_AND_SWITCH_TO_POLYGON')}</span>
                    <Button variant="cdh-general-blue-dbrown" onClick={() => switchNetwork(PolygonNetworkInfo)}>
                        <span>{t('SWITCH_BTN')}</span>
                    </Button>
                </div>
                :
                <div className={styles.no_items_section}>
                    <div className={styles.main_text}>{t('CONNECT_WALLET_ACCESS_INVENTORY')}</div>
                    <div className={styles.secondary_text}>{t('NO_ITEMS_WITHOUT_CONNECT')}</div>
                    <Button variant="cdh-general-blue-dbrown" className={styles.primary_btn} onClick={connect}>{t('CONNECT')}</Button>
                </div>}
        </>
    );

    const renderTicketsSection = (
        <Tickets
            walletConnected={walletConnected}
        />
    );

    const renderSkinSection = (
        <Skins
            walletConnected={walletConnected}
        />
    );

    const renderMapsSection = (
        <Maps walletConnected={walletConnected} />
    )

    return (
        <>
            <div className={styles.inventory_container}>
                <section className={styles.header_container}>
                    <div className={styles.header_items} >
                        <div className={styles.header_title}>
                            <div className={styles.header}>{t('INVENTORY')}</div>
                            <div className={styles.details}>
                                {t('TOWER_TOKEN_DESCRIPTION')}
                            </div>
                        </div>
                        
                        {/* Hide user inventory information i.e. wallet address, no. of chests, no. of cards, etc */}
                        {/* <div className={styles.user_inventory_info}>
                            <div>
                                {
                                    selectedAccount &&
                                    <div className={styles.wallet}>{t('WALLET_ADDRESS')}&nbsp;<b>{selectedAccount}</b></div>
                                }
                            </div>
                            <div className={styles.user_chest_cards_info}>
                                <div className={styles.chest_cards_info}>
                                    <div className={styles.item_image}>
                                        <img src={ChestIcon} alt="chest" />
                                    </div>
                                    <div className={styles.item_type_amount}>
                                        <div className={styles.item_text}>{t('TOTAL_NO_OF_CHESTS')}</div>
                                        <div className={styles.item_amount}>{state.totalChestCount > 0 ? state.totalChestCount : '--'}</div>
                                    </div>
                                </div>
                                {
                                    CARD_NFTS_ENABLED === "true" &&
                                    <div className={styles.chest_cards_info}>
                                        <div className={styles.item_image}>
                                            <img src={CardsIcon} alt="chest" />
                                        </div>
                                        <div className={styles.item_type_amount}>
                                            <div className={styles.item_text}>{t('TOTAL_NO_OF_CARDS')}</div>
                                            <div className={styles.item_amount}>{state.totalCardCount > 0 ? state.totalCardCount : '--'}</div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div> */}
                    </div>
                </section>
                {/* {networkId !== 1 && networkId !== 5 && networkId !== null &&
                        <div className={styles.network_message}>
                            <div className={styles.network_message_container}>
                                <span className={styles.network_message_text}>
                                    {t('SWITCH_NETWORK_MSG').slice(0, 22)}
                                    <u className={styles.switch_button} onClick={() => {switchNetwork(NetInfo)}}>{t('SWITCH_NETWORK_MSG').slice(-27, -1)}</u>
                                    {t('SWITCH_NETWORK_MSG').slice(-1)}
                                </span>
                            </div>
                        </div>
                    } */}
                <section className={styles.inventory_box_container}>

                    <div className={styles.inventory_box}>
                        <div className={styles.inventory_section_types}>
                            
                            {/* Rendering of cards tab */}
                            { CARD_NFTS_ENABLED === "true" &&
                                <div
                                    className={`${styles.items_types_title} ${selectedInventorySection === 'cards' ? styles.selected : styles.unselected}`}
                                    onClick={() => history.push('/inventory/cards')}
                                >
                                    <div className={styles.title_icon}>
                                        <img src={selectedInventorySection === 'cards' ? CardsIcon : CardsIconGray} alt="cards" />
                                    </div>
                                    <div className={styles.title_text}>{t('CARDS')}</div>
                                </div> }
                            
                            {/* Rendering of tickets tab */}
                            {(SKIN_AND_TICKET_BRIDGING_ENABLED === "true") && <div
                                className={`${styles.items_types_title} ${selectedInventorySection === 'tickets' ? styles.selected : styles.unselected}`}
                                onClick={() => history.push('/inventory/tickets')}
                            >
                                <div className={styles.title_icon}>
                                    <img src={selectedInventorySection === 'tickets' ? TicketIcon : TicketIconGray} alt="tickets" />
                                </div>
                                <div className={styles.title_text}>{t('TICKETS')}</div>
                            </div> }

                            {/* Rendering of maps tab */}
                            {(MAPS_NFTS_ENABLED === "true") && <div
                                className={`${styles.items_types_title} ${selectedInventorySection === 'maps' ? styles.selected : styles.unselected}`}
                                onClick={() => history.push('/inventory/maps')}
                            >
                                <div className={styles.title_icon}>
                                    <img src={selectedInventorySection === 'maps' ? MapIcon : MapIconGray} alt="maps" />
                                </div>
                                <div className={styles.title_text}>{t('MAPS')}</div>
                            </div> }
                            
                            {/* Rendering of skins tab */}
                            {(SKIN_AND_TICKET_BRIDGING_ENABLED === "true") && <div
                                className={`${styles.items_types_title} ${selectedInventorySection === 'skins' ? styles.selected : styles.unselected}`}
                                onClick={() => history.push('/inventory/skins')}
                            >
                                <div className={styles.title_icon}>
                                    <img src={selectedInventorySection === 'skins' ? SkinIcon : SkinIconGray} alt="skin" />
                                </div>
                                <div className={styles.title_text}>{t('SKINS')}</div>
                            </div> }

                            {/* Rendering of chests tab */}
                            <div
                                className={`${styles.items_types_title} ${selectedInventorySection === 'chests' ? styles.selected : styles.unselected}`}
                                onClick={() => history.push('/inventory/chests')}
                            >
                                <div className={styles.title_icon}>
                                    <img src={selectedInventorySection === 'chests' ? ChestIcon : ChestIconGray} alt="chest" />
                                </div>
                                <div className={styles.title_text}>{t('CHESTS')}</div>
                            </div>
                        </div>

                        {/* Actual rendering of inventory items section */}
                        <div className={styles.inventory_items_section}>
                            {
                                selectedInventorySection === 'cards' ?
                                renderCardsSection :
                                selectedInventorySection === 'tickets' ?
                                renderTicketsSection :
                                selectedInventorySection === 'maps' ?
                                renderMapsSection :
                                selectedInventorySection === 'skins' ?
                                renderSkinSection :
                                selectedInventorySection === 'chests' ?
                                renderChestSection :
                                renderCardsSection
                            }
                        </div>
                    </div>
                </section>
                <ConnectModal content={{
                    show: showConnectModal,
                    showSetter: setShowConnectModal
                }} />
            </div>
        </>
    );
}

export { Inventory };
